import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';


function CommissionPaymentComponentLeft(props) {
    const commissions = _adviserPortalHome._commissionPaymentDetailsGroup(props)
    const { t } = props;
    return (
        <tbody>
            <tr><td><div><Link className="adviserLoginLink link" to={'/adv/commissionPayment/'+commissions.previous[0].startDate}>
                <div className="adviserDataTotal"><CurrencyFormat value={Number(commissions.previousFee).toFixed(2)}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'} /></div>
                     <div>{t('Fees:prevPayment')}</div>
                <div>{commissions.previous[0].month}</div></Link></div></td></tr>
                {/* {t('Fees:totalFeePaid')} </Link></div></td></tr> */}
            {/* <tr><td><div><Link className="adviserLoginDataLink link" to='/adv/commissionPayment/due'>
                <div className="adviserDataSplit"><CurrencyFormat value={Number(commissions.currentFee).toFixed(2)}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'} /></div>
                <div>{t('Fees:nextPayment')}</div>
                <div>{commissions.current[0].month}</div></Link></div></td></tr> */}
            {/* <tr>
                <td><div className="adviserDataSplit">{totalMembersDetails.invest}</div>
                <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLI">{t('Superlife Invest Members')}</Link></div></td>
                </tr>
                <tr>
                <td><div className="adviserDataSplit">{totalMembersDetails.ukPension}</div>
                <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLKS">{t('Superlife UK Members')}</Link></div></td>
                </tr> */}
        </tbody>
    )
}

export default withTranslation()(CommissionPaymentComponentLeft);